// extracted by mini-css-extract-plugin
module.exports = {"root":"Instruction_root__1GShi","hasIcon":"Instruction_hasIcon__3bZEh","item":"Instruction_item__3CmNk","itemInside":"Instruction_itemInside__zP4GD"};